import DelightRenderer from '@app/modules/Delights/DelightRenderer';
import Tracking from '@components/Tracking';
import { BreadcrumbProvider } from '@contexts/BreadcrumbContext';
import { appRoutesConfig } from '@data/routes';
import StoreProvider from '@providers/StoreProvider';
import { AntAppUtil, ErrorBoundary } from '@repo/ui';
import { ActionCableProvider, AntdConfigProvider, ThemeProvider } from '@repo/utils';
import { App } from 'antd';
import { Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';

const router = createBrowserRouter(
  appRoutesConfig(),
);

function BaseApp(): JSX.Element {
  return (
    <StoreProvider>
      <HelmetProvider>
        <BreadcrumbProvider>
          <ThemeProvider>
            <AntdConfigProvider>
              <ErrorBoundary>
                <App className="antAppContainer">
                  <Suspense>
                    <Tracking />
                    <AntAppUtil />
                    <ErrorBoundary>
                      <ActionCableProvider url="/core/cable">
                        <RouterProvider router={router} />
                      </ActionCableProvider>
                    </ErrorBoundary>
                    <ErrorBoundary fallback={null}>
                      <DelightRenderer />
                    </ErrorBoundary>
                  </Suspense>
                </App>
              </ErrorBoundary>
            </AntdConfigProvider>
          </ThemeProvider>
        </BreadcrumbProvider>
      </HelmetProvider>
    </StoreProvider>
  );
}

export default BaseApp;
